<template>
  <div class='xy-content-module'>
    <div class='xy-content-title xy-flex xy-between xy-center'>
      <div><!--这里是按钮 --></div>
      <div><!--这里是右侧的筛选 --></div>
    </div>
    <div class='xy-content-body'>
      <div class="changeAll" >
        <div class="chang-school" @click="showSchool">
          <span>{{schoolName ? schoolName:''}}</span>
           <img src="./img/down.png" alt="" >
        </div>
        <div class="chang-grade" @click="showGrade">
          <span>{{gradeName ? gradeName: ''}}</span>
           <img src="./img/down.png" alt="" >
        </div>
        <div class="chang-class" @click="showClass">
          <span>{{className ? className : ''}}</span>
           <img src="./img/down.png" alt=""  v-show="className">
        </div>
      </div>
      <van-popup v-model="isShowschool" position="bottom" :style="{ height: '50%' }" >
        <div style="text-align: center;" v-for="(item,index) in layerList" :key="index" @click="changeSchool(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <van-popup v-model="isShowgrade" position="bottom" :style="{ height: '50%' }"  @click-overlay="onGrade">
        <div style="text-align: center;" v-for="(item,index) in layerListGrade" :key="index" @click="changeGrade(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <van-popup v-model="isShowclass" position="bottom" :style="{ height: '50%' }" @click-overlay="onClass">
        <div style="text-align: center;" v-for="(item,index) in layerListClass" :key="index" @click="changeClass(item)">
          <div style="font-size:18Px;padding:18px">{{item.label ? item.label:'没有班级可选' }}</div>
        </div>
      </van-popup>
      <div class="group">
        <!-- 班级列表 -->
        <div class="group_left group_bottom">
          <div   class="card_list">
            <div :class="['card',{seletcard:item.checked}]" v-for="(item,index) in  gradeList" :key="index"  @click="checkStudent(item)">
              <div class="showline">
                  <div class="left_name">
                    <img v-if="item.Icon" :src="item.Icon" />
                    <span v-if="!item.Icon" class="aviter" :style="{background:item.Sex?'#4196ff':'#ff8c8c'}"
                      >{{ xy.showName(item.StudentName) }}
                    </span>
                  </div>
                  <div class="right_content">
                    <div class="name">{{ item.StudentName }}</div>
                    <div class="source">{{item.Score }}</div>
                  </div>
              </div>
              <div  class="selspn" v-show="item.checked"></div>
            </div>
          </div>
          <div class="assessView null-data" v-if="gradeList.length===0 && gradeIsLoad">
            <img src="@/assets/common/moblie-no-data.png" />
            <div>该班级暂无学生。</div>
          </div>
        </div>
        <!-- <div class="assessView null-data" v-if="list.length === 0 && isLoad">
          <img src="@/assets/common/moblie-no-data.png" />
          <div>该搜索条件下暂无结果。</div>
        </div> -->
        <!--指标-->
        <div class="group_right group_bottom">
          <div class="assessView null-data" v-if="list.length === 0 && isLoad">
            <img src="@/assets/common/moblie-no-data.png" />
            <div>该搜索条件下暂无结果。</div>
          </div>
         
          <div class="index-box" >
            <van-collapse v-model="activeNames">
              <van-collapse-item    
                  v-for="(i, j) in list" 
                  :key="j"  
                  :title='i.label' 
                  :name="j"
                  size="16"
                  >
              <div class="sec-index"> </div>
              <ul class="th-index-list">
            <!-- 无三级指标 --> 
                <li :class="['th-index', {seletGroup:i.checked}]" v-if="i.children.length === 0"  @click="ischeck(i, !i.checked,1)">
                  <!--<van-checkbox style="border-radius: 2px" icon-size="22" checked-color="#1677FF" shape="square" v-model="i.checked" @click="ischeck(i, false)"></van-checkbox>-->
                  <div class="index-li">
                    <p class="index-txt">{{i.label}} </p>
                    <div @click.stop="clear(i)" v-if="i.ScoreType === 1" class="operat">
                      <van-rate @change="ischeck(i, true)" v-model="i.scoredefault" :count="i.scoremax" void-icon="star" color="#FADB14" :size="26" />
                    </div>
                    <div class="score-slider" v-else>
                      <span>{{i.scoremin}}分</span>
                      <van-slider @change="ischeck(i, true)" :min="i.scoremin" :max="i.scoremax" v-model="i.scoredefault" bar-height="10px" active-color="#4196FF">
                        <template #button>
                          <div class="seekBar">
                            <div class="bubble">{{i.scoredefault}} </div>
                          </div>
                        </template>
                      </van-slider>
                      <span>{{i.scoremax}}分</span>
                    </div>
                  </div>
                </li>
            <!-- 有三级指标 -->
                <li :class="['th-index', {seletGroup:item.checked}]" v-else v-for="(item, index) in i.children" :key="index"  @click="ischeck(item,  !item.checked,1)">
                  <!--<van-checkbox style="border-radius: 2px" icon-size="22" checked-color="#1677FF" shape="square" v-model="item.checked" @click="ischeck(item, false)"></van-checkbox>-->
                  <div class="index-li">
                    <p class="index-txt">{{item.label}} </p>
                    <div @click.stop="clear(item)" v-if="i.ScoreType === 1" class="operat">
                      <van-rate @change="ischeck(item, true)" v-model="item.scoredefault" :count="item.scoremax" void-icon="star"   void-color="#eee"  color="#FADB14" :size="26" />
                    </div>
                    <div class="score-slider" v-else>
                      <span>{{item.scoremin}}分</span>
                      <van-slider @change="ischeck(item, true)" :min="item.scoremin" :max="item.scoremax" v-model="item.scoredefault" bar-height="10" active-color="#4196FF">
                        <template #button>
                          <div class="seekBar">
                            <div class="bubble">{{item.scoredefault}} </div>
                          </div>
                        </template>
                      </van-slider>
                      <span>{{item.scoremax}}分</span>
                    </div>
                  </div>
                </li>
              </ul>
              </van-collapse-item>
            </van-collapse>
          </div>        
        </div>
      </div>
      <!-- <div class="sigle-bottom-btn">
        <div class="select-class" @click="checkClass">选择学生</div>
      </div> -->
      <div class=" sigle-bottom-btn  ">
      <!-- <div class="select-class" @click="checkClass">选择学生</div> -->
        <div class="left">
          <van-checkbox v-model="checkedAll" shape="round" @click="selectedAll"></van-checkbox>
          <span>全选学生</span>
        </div>
        <div class="save" @click="btnSave">保存</div>
      </div>
      <div class="showCover" v-if="showCover">
        <van-popup v-model="showCover">
          <div class="mask">
            <img src="./img/notice.png" alt="">
            <div class="text">为了更好的使用，请您横屏使用</div>
            <div class="close" @click="showCover =  false">
              知道了
            </div>
          </div>
      
        </van-popup>
      </div>
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant'
  export default {
    name: 'MoralEducation',
    data () {
      return {
        scoredefault:10,
        activeNames:['0'],
        checkedAll:false,
        schoolgradeId11:'',
        showCover:false,
        num:0,
        name:'',
        rateUrl: require('./img/voidRate.png'),
        // 指标
        list: [],
        layerList:[],
        layerListGrade:[],
        layerListClass:[],
        schoolName:'',
        gradeName:'',
        className:'',
        schoolId:'',
        gradeId:'',
        classId:'',

        show:false,
        isShowschool:false,
        isShowgrade:false,
        isShowclass:false,
        scoreDatas: [],
        popupData: [],

        isLoad: false,
        oldSchoolData:[],
        gradeList:[],//班级列表
        gradeIsLoad:false,//判断班级列表是否有数据
        selectAll:[],//选中的学生
      }
    },
    created () {
      // this.GetUserRangeClassPermission()
    },
    // beforeRouteEnter(to, from, next) {
    //   next(vm=>{
    //       let schoolgradeId11 = JSON.parse(localStorage.getItem("schoolgradeId11"))
    //       if(from.name === 'MoralStudentsList'){
    //         vm.GetUserRangeClassPermission(schoolgradeId11)
    //       }else{
    //         vm.GetUserRangeClassPermission()
    //       }
    //     })
    // },
    beforeRouteEnter(to, from, next) {
      next(vm=>{
          vm.schoolgradeId11 = JSON.parse(localStorage.getItem("schoolgradeId11"))
          vm.name = from.name
          // let schoolgradeId = JSON.parse(localStorage.getItem("schoolgradeId"))
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          if(height<width){
            vm.getList()
          }else{
            console.log(vm.name)
          }
        })
    },
    mounted() {
      window.addEventListener("resize", this.watch, false);
      this.watch();
    },
    beforeDestroy() {
    // 移除监听
      window.removeEventListener("resize", this.watch, false);
    },
    methods: {
      selectedAll(){
        this.selectAll=[]
        this.gradeList.map(item=>{
          item.checked = this.checkedAll
          if(item.checked){
            this.selectAll.push(item)
          }else{
            this.selectAll=[]
          }
        })
      },
      btnSave(){
         if (this.scoreDatas.length === 0) {
          this.fail("请先选择指标。")
          return false
        }
        if (this.selectAll.length !== 0) {
          this.saveScore()
        } else {
          this.fail("请先选择要评价的学生。")
        }
      },
      async saveScore(){
        this.loading()
        let pickList = []
        let arr = this.selectAll.concat([])
         for (var x = 0; x < arr.length; x++) {
          for (var y = 0; y < this.scoreDatas.length; y++) {
            let aa = {}
            aa.IndexManagementID = this.scoreDatas[y].value
            aa.Score = this.scoreDatas[y].scoredefault
            aa.AcademicSessionID = arr[x].AcademicSessionID
            aa.AcademicSessionName = arr[x].AcademicSessionName
            aa.AcademicYearID = arr[x].AcademicYearID
            aa.AcademicYearName = arr[x].AcademicYearName
            aa.AccountID = arr[x].AccountID
            aa.Conversion = arr[x].Conversion
            aa.ConversionScore = arr[x].ConversionScore
            aa.IndicatorTypeID = arr[x].IndicatorTypeID
            aa.IsDelete = arr[x].IsDelete
            aa.LastDeleteByDate = arr[x].LastDeleteByDate
            aa.LastDeleteByID = arr[x].LastDeleteByID
            aa.ProgrammeID = arr[x].ProgrammeID
            aa.RecordDate = arr[x].RecordDate
            aa.RecordID = arr[x].RecordID
            aa.SchoolDistrictID = arr[x].SchoolDistrictID
            aa.SchoolDistrictName = arr[x].SchoolDistrictName
            aa.ScoreByID = arr[x].ScoreByID
            aa.ScoreDate = arr[x].ScoreDate
            aa.ScoreType = arr[x].ScoreType
            aa.StarScore = arr[x].StarScore
            aa.StudentGradeForStudentYearID = arr[x].StudentGradeForStudentYearID
            aa.StudentGradeID = arr[x].StudentGradeID
            aa.StudentGradeNameForStudentYearName = arr[x].StudentGradeNameForStudentYearName
            aa.StudentID = arr[x].StudentID
            aa.StudentName = arr[x].StudentName
            aa.StudentOrganizationId = arr[x].StudentOrganizationId
            aa.StudentOrganizationName = arr[x].StudentOrganizationName
            aa.StudentYearID = arr[x].StudentYearID
            aa.UserName = arr[x].UserName
            aa.WeekDay = arr[x].WeekDay
            pickList.push(aa)
          }
        }
        console.log(pickList)
        let res = await this.xyapi.post(`${this.xyMApi}/eva/api/MoralScoreRecordByPad/SaveScoreRecodStudentByPad`, {
          MoralEducationScoreRecordStudentList: pickList
        })
        this.unloading()
        if (res.success) {
          this.fail(res.msg || '保存成功。', true)
          this.scoreDatas =  []
          this.selectAll = []
          setTimeout(() => {
            this.getClassList()  // 获取学生列表
            this.getListTaget()  //获取指标
            this.checkedAll = false
          }, 1000)
        }
      },
      // 选择学生
      checkStudent(item){
        item.checked = !item.checked
        this.selectAll=[]
        this.gradeList.map(item=>{
          if(item.checked){
            this.selectAll.push(item)
          }else{
            item.checked = false
          }
        })  
        this.checkedAll =  this.selectAll.length === this.gradeList.length?true:false
        if(this.selectAll.length === 1){
          this.getGetClassIndex(item.StudentID)
        }else if(this.selectAll.length === 2 || this.checkedAll){
          console.log("????")
           this.getListTaget()
        }


        //  判断点击一次学生 调取 
      // console.log(this.selectAll.length)
      //   if( this.selectAll.length===1){
      //     this.getGetClassIndex(item.StudentID)
      //   }else{
      //      this.getListTaget()
      //   }
      },

     async getGetClassIndex(id){
       this.xy.loading()
        let params = {
          SchoolDistrictID:this.schoolId,
          StudentGradeForStudentYearID:this.gradeId,
          Dimension:1,
          StudentOrganizationId:this.classId,
          studentID:id
        }
        this.xy.unloading()
        let res = await this.xyapi.get(`${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetClassIndexManagementListByStudentID`, params)
        if(res.success){
          this.list = res.data
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].children.length !== 0) {
              this.list[i].children.map((item) => {
                this.$set(item, 'checked', false)
                this.$set(item, 'isChange', false)
              })
            } else {
              this.$set(this.list[i], 'checked', false)
              this.$set(this.list[i], 'isChange', false)
            }
          }
          this.isLoad = true
        }

      },
      unloading() {
        Toast.clear()
      },
      // 获取学生列表
      async getClassList() {
        this.loading()
        let res = await this.xyapi.get(
          `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetMoralStudentListByPad`,
          {
            SchoolDistrictID: this.schoolId,
            StudentGradeForStudentYearID: this.gradeId,
            StudentOrganizationId: this.classId
          }
        )
        if (res.success) {
          this.gradeList = res.data
          this.gradeIsLoad = true
          this.gradeList.forEach ((item) => {
            this.$set(item, 'checked', false)
          })
        }
        if(this.gradeIsLoad && this.isLoad ){
          this.xy.unloading()
        }
        // this.xy.unloading()
      },
      watch(){
        // if(!window.isIpad){
          // 判断横竖屏
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          if(height>width){
            this.showCover = true
          }else{
            this.showCover = false
            this.num++
            if(this.num === 1){
               this.getList()
            } 
          }
        // }
      },
      getList(){
        if(this.name === 'MoralStudentsList'){
          this.GetUserRangeClassPermission(this.schoolgradeId11)
        }else{
          this.GetUserRangeClassPermission()
        }
      },
      loading() {
        Toast.loading({
          duration: 0,
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      fail(a,b) {
        if(b){
          Toast.success({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        }else{
          Toast.fail({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        }
      },
      checkClass () {
        if (this.scoreDatas.length !== 0) {
          localStorage.setItem("schoolgradeId11", JSON.stringify({"schoolId": this.schoolId,"schoolName":this.schoolName,"gradeId": this.gradeId,"gradeName":this.gradeName,"classId":this.classId,"className":this.className}))
          this.$router.push({
            path: "/ipad/MoralStudentsList",
            query: {
              schoolId: this.schoolId,
              gradeId: this.gradeId,
              classId: this.classId,
              scoreDatas: this.scoreDatas
            }
          })
        } else {
          this.fail("请先选择指标。",false)
        }
      },
      showSchool(){
        this.isShowschool = true
        this.isShowgrade = false
        this.isShowclass = false
      },
      showGrade(){
        this.isShowschool = false
        this.isShowgrade = true
        this.isShowclass = false
      },
      showClass(){
        this.isShowschool = false
        this.isShowgrade = false
        this.isShowclass = true
      },
      //获取学年
      async GetUserRangeClassPermission(schoolgradeData) {
        // let idArr = this.$store.state.common.menuIDs
       let idArr  =  this.$store.state.evaluation.ipadpjgetMenuIDs
        this.applicationID = idArr[0]
        this.applicationSubMenuID = idArr[1]
        let res = await this.xyapi.get(
         `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetUserRangeClassPermissionNodeListByProgrammeByPad`,
          {
            applicationID: this.applicationID,
            applicationSubMenuID: this.applicationSubMenuID
          }
        )
        if (res.success) {
          let layerList = [];
          layerList = res.data;
          if (layerList.length > 0) {
            this.layerList = layerList
            //默认第一个
            this.schoolName = this.layerList[0].label
            //默认调用changeSchool
            // this.changeSchool(this.layerList[0])
            if (schoolgradeData === undefined){
                this.changeSchool(this.layerList[0])
            }else{
                for(var i=0;i<this.layerList.length;i++){
                  if (this.layerList[i].value === schoolgradeData.schoolId){
                    this.changeSchool(this.layerList[i],'checked')
                    for(var n=0;n<this.layerList[i].children.length;n++){
                      if (this.layerList[i].children[n].value === schoolgradeData.gradeId){
                        this.changeGrade(this.layerList[i].children[n],'checked')
                        for(var k=0;k<this.layerList[i].children[n].children.length;k++){
                           if (this.layerList[i].children[n].children[k].value === schoolgradeData.classId){
                              this.changeClass(this.layerList[i].children[n].children[k])
                           }
                        }
                      }
                    }
                  }
                }
            }
          } else {
            this.fail("您无有效的年级班级",false)
          }
        } else {
          this.fail(res.msg,false)
        }
      },
      //选择校区
      changeSchool(item,ischeck){
        this.schoolName = item.label
        this.schoolId = item.value
        this.isShowschool = false
        this.layerListGrade = item.children
        if(ischeck === 'checked'){
          this.isShowgrade = true
        }else{
          //默认选择第一个
          this.gradeName = this.layerListGrade.length>0 ? this.layerListGrade[0].label : ''
          this.changeGrade(this.layerListGrade[0])
        }
      },
      //选择年级
      changeGrade(item,ischeck){
        this.gradeName = item.label
        this.gradeId = item.value
        this.isShowgrade = false
        this.layerListClass = item.children
        //默认选择第一个
        if(ischeck === 'checked'){
          this.isShowclass = true
        }else{
          if (this.layerListClass.length > 0) {
            //默认选择第一个
            this.className = this.layerListClass.length>0 ? this.layerListClass[0].label : ''
            this.changeClass(this.layerListClass[0])
          } else {
            this.isLoad = true
          }
        }
      },
      //班级
      changeClass(item){
        this.className = item.label
        this.classId = item.value
        this.isShowclass = false
        this.getListTaget()  //获取指标
        this.getClassList()  // 获取学生列表
        this.oldSchoolData = {
          sName:this.schoolName,
          sId:this.schoolId,
          sList:this.layerList,
          gName:this.gradeName,
          gId:this.gradeId,
          gList:this.layerListGrade,
          cName:this.className,
          cId:this.classId,
          cList:this.layerListClass
        }
       
       
      },
      //点击蒙层取消选择年级-班级
      onGrade(){
        this.schoolName = this.oldSchoolData.sName
        this.schoolId = this.oldSchoolData.sId
        this.layerList = this.oldSchoolData.sList
        this.gradeName = this.oldSchoolData.gName
        this.gradeId = this.oldSchoolData.gId
        this.layerListGrade = this.oldSchoolData.gList
        this.className = this.oldSchoolData.cName
        this.classId = this.oldSchoolData.cId
        this.layerListClass = this.oldSchoolData.cList
      },
      onClass(){
        this.schoolName = this.oldSchoolData.sName
        this.schoolId = this.oldSchoolData.sId
        this.layerList = this.oldSchoolData.sList
        this.gradeName = this.oldSchoolData.gName
        this.gradeId = this.oldSchoolData.gId
        this.layerListGrade = this.oldSchoolData.gList
        this.className = this.oldSchoolData.cName
        this.classId = this.oldSchoolData.cId
        this.layerListClass = this.oldSchoolData.cList
      },
      //获取指标列表
     async getListTaget(){
      //  this.loading()
        let params = {
            SchoolDistrictID:this.schoolId,
            StudentGradeForStudentYearID:this.gradeId,
            Dimension:1,
            StudentOrganizationId:this.classId
        }
        let res = await this.xyapi.get(
         `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetClassIndexManagementListByPad`,params
        )
        // this.xy.unloading()
        if (res.success) {
          this.list = res.data
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].children.length !== 0) {
              this.list[i].children.map((item) => {
                this.$set(item, 'checked', false)
                this.$set(item, 'isChange', false)
              })
            } else {
              this.$set(this.list[i], 'checked', false)
              this.$set(this.list[i], 'isChange', false)
            }
          }
          this.isLoad = true
        }
     },
      ischeck (item, sel,type=2) {
        this.dItem = item.scoredefault
        this.minItem = item.scoremin
        item.isChange = item.scoredefault === 1 ? true : false
        if(type === 1) item.checked = false
        // 默认值小于设置的最小值时 取消选中
        if (item.scoredefault < item.scoremin) {
          item.checked = false
          let ins = -1
          for(let i=0,len=this.scoreDatas.length;i<len;i++){
            if(!this.scoreDatas[i].checked){
              ins=i
            }
          }
          if(ins!==-1){ this.scoreDatas.splice(ins,1) }
          this.fail(`指标项评价最小值为${item.scoremin}`,false)
          return false
        }
        setTimeout(() => {
          item.isChange = item.scoredefault === 1 ? false : true
          if (sel && !item.checked) {
            item.checked = true
            this.scoreDatas.push(item)
          } else if (!sel) {
            let indexs = -1
            item.checked = item.checked ? false :true
            item.checked = !item.checked ? true :false
            if (item.checked) {
              
               for(let i=0,len=this.scoreDatas.length;i<len;i++){
                if(this.scoreDatas[i].value ===item.value){
                  indexs=i
                }
              }
              this.scoreDatas.splice(indexs,1)     
              this.scoreDatas.push(item)
            }else{
              for(let i=0,len=this.scoreDatas.length;i<len;i++){
                if(this.scoreDatas[i].value ===item.value){
                  indexs=i
                }
              }
            }
            if(indexs!==-1)
              this.scoreDatas.splice(indexs,1)     
          }
        }, 100)
      },
      // 清除选择
      clear (item) {
        // 原本等于1 或者 改变得分为1后再次点击
        if (item.scoredefault === 1 && !item.isChange) {
          item.scoredefault = 0
          this.dItem = item.scoredefault
          this.minItem = item.scoremin
          if (item.scoredefault >= item.scoremin) {
            item.checked = true
            item.isChange = false
            let indexs =-1
              for(let i=0,len=this.scoreDatas.length;i<len;i++){
                if(this.scoreDatas[i].value ===item.value){
                  indexs=i
                }
              }
            this.scoreDatas.splice(indexs,1)   
            this.scoreDatas.push(item)
          } else {
            item.checked = false
            let ins = -1
            for(let i=0,len=this.scoreDatas.length;i<len;i++){
              if(!this.scoreDatas[i].checked){
                ins=i
              }
            }
            if(ins!==-1){ this.scoreDatas.splice(ins,1) }
            this.fail(`指标项评价最小值为${item.scoremin}`,false)
            return false
          }
        }
      }
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-checkbox__icon{
  font-size: 22px;
}
.xy-content-body {
  //margin-bottom: 160px; 
  /deep/ img {
    vertical-align: baseline !important;
  }
}
/deep/ .van-collapse-item__content {
  padding: 0;
}
 
/deep/ .van-cell{
  line-height: 50px;
  padding: 4px 20px;
}

/deep/ .van-cell__title {
  font-size: 16px;
}
/deep/ .van-cell__right-icon{
   font-size: 24px !important;
}
/deep/ .van-rate__item {
  padding-left: 10px;
  padding-right: 0;
}
/deep/ .van-rate__item:first-child{
  padding: 0;
}
.assessView {
  width: 100%;
  height: 560px;
}
.null-data {
  //margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.changeAll{
  background: #fff;
  height: 44px;
  width: 100%;
  font-size: 15Px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: rgba(0,0,0,0.65);
  div{
    padding:10px;
    flex: 1;
    text-align: center;
    img{
      width:10px;
      height:6px;
      margin-left:5px;
    }
  }
}
.index-box {
  width: 100%;
  .sec-index {
    font-size: 16Px;
    margin: 10px 0;
    padding-left: 20px;
    color: rgba(0,0,0,0.35);
  }
  .th-index-list {
    padding: 0 10px 0 15px;
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
   
    .th-index{
      width: 49%;
      box-sizing: border-box;
      border-radius: 4px;
      border:1px solid #d5d5d5;
      margin: 5px 0;
      padding: 10px 10px 5px ;
      position: relative;
      .index-li{
          .index-txt{
             height:35px;
            line-height:18px;
            font-size: 16px;
            font-size:16px;
            overflow: hidden;
            text-overflow:ellipsis;    
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .operat{
            font-size: 16px;
            width: 45%;
            height: 30px;
            line-height: 30px;
          }
      }
      .score-slider {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 16Px;
            color: rgba(0,0,0,0.45);
            display: inline-block;
          }
          .seekBar {
            width: 30px;
            height: 30px;
            background: url(./img/score.png) no-repeat top left;
            background-size: 100% 100%;
            position: relative;
            .bubble {
             width: 100%;
             height: 100%;
              // background: url(./img/bubble.png) no-repeat;
              color: #1677FF;
              font-size: 16px;
              text-align: center;
              line-height: 30px;
              position: absolute;
              left: 0;
              top: 0;
            }
          }
          /deep/ .van-slider {
            width: 60%;
            margin: 0 18px 0 18px;
          }
        }
    }
    // .th-index {
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   margin-bottom: 10px;
    //   .index-li {
    //     background: #fff;
    //     display: flex;
    //     flex: 1;
    //     align-items: center;
    //     justify-content: space-between;
    //     width: 658px;
    //     margin-left: 15px;
    //     height: 90px;
    //     align-items: center;
    //     //padding: 20px 10px 0px 19px;
    //     padding: 0 15px;
    //     box-sizing: border-box;
    //     border-radius: 4px;
    //     border:1px solid #d5d5d5;
    //     p {
    //       font-size: 16Px;
    //       color: rgba(26,26,26,0.85);
    //       font-weight: bold;
    //       height: 42px;
    //       width: 362px;
    //     }
    //     .score-slider {
    //       display: flex;
    //       align-items: center;
    //       justify-content: space-between;
    //       span {
    //         font-size: 16Px;
    //         color: rgba(0,0,0,0.45);
    //         display: inline-block;
    //       }
    //       .seekBar {
    //         width: 36px;
    //         height: 36px;
    //         background: url(./img/score.png) no-repeat top left;
    //         background-size: 36px;
    //         position: relative;
    //         .bubble {
    //           width: 48px;
    //           height: 36px;
    //           background: url(./img/bubble.png) no-repeat;
    //           color: #1677FF;
    //           font-size: 16Px;
    //           text-align: center;
    //           line-height: 30px;
    //           position: absolute;
    //           left: -5px;
    //           top: -36px;
    //         }
    //       }
    //       /deep/ .van-slider {
    //         width: 164px;
    //         margin: 0 18px 0 18px;
    //       }
    //     }
    //   }
    // }



    .custom-button {
      width: 24px;
      color: #fff;
      font-size: 10Px;
      line-height: 24px;
      text-align: center;
      background-color: #4196FF;
      border-radius: 100%;
    }
  }
}

.sigle-bottom-btn {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  align-items: center;
  justify-content: space-around;
  padding: 0 20px 0 30px;
  .select-class {
    font-size: 16Px;
    color: #1677ff;
  }
  .info-btn {
    width: 74px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
  .save{
  width: auto;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #267dff;
  border-radius: 40px;
  color:#fff;
  font-size: 14Px;
  padding:0 23px;
}
.left{
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: rgba(0,0,0,0.85);
  display: flex;
  span{
    margin-left:13px;
    color:rgba(0,0,0,0.85);
  }
}
}

.mask{
  width: 600px;
  height: 365px;
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  img{
    position: absolute;
    top: -82px;
    left: 50%;
    width:162px;
    height: 202px;
    transform: translate(-50%,7px)
  }
  .text{
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #2b2b2b;
    padding-top: 141px;
  }
  .close{
    margin:70px auto;
    width: 200px;
    height: 70px;
    background: #1677ff;
    border-radius: 35px;
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color:#fff;
    text-align: center;
    line-height: 70px;
  }
}
.showCover{
  /deep/ .van-popup{
  overflow-y: inherit;
  }
}
.group{
   display: flex;
   align-items: center;
   margin-bottom:10px;
   margin-top: 20px;
   background: #f5f5f5;
}
.group_left{
  width:315px;
  background: #ffffff;
  height:560px;
  overflow: auto;
}
.group_right{
  height:560px;
  flex:1;
  background: #fff;
  margin-left:10px;
  overflow: auto;
}
.group_bottom{
  padding-bottom: 80px;
}
.card_list{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 10px;
}
.card {
  width: 126px;
  height: 90px;
  box-sizing: border-box;
  background: white;
  border-radius: 4px;
  margin: 5px 7px;
  border: 1px white solid;
  position: relative;
}

.seletcard{
  border: 1px #1677FF solid;

}
.showline {
  height: 100%;
  line-height: 93px;
  background: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  display: flex;
}

.left_name {

  img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    vertical-align: top;
    margin-top: 29px;
    margin-left:10px;
    
  }
  .aviter {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    vertical-align: top;
    margin-top: 29px;
    margin-left:10px;
    background: #4196ff;
    line-height: 36px;
    // prettier-ignore
    font-size: 14Px;
    color: white;
    text-align: center;
   
  }
}
.right_content{
  flex:1;
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 0 8px;
  .name {
    // prettier-ignore
   font-size: 16px;
   font-family: PingFangSC, PingFangSC-Medium;
   font-weight: 500;
   text-align: center;
   color: rgba(0,0,0,0.85);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    line-height: 24px;
  }
  
}
.source {
  font-size: 36px;
  color: rgba(226,141,48,1);
  line-height: 24px;
  margin-top: 5px;
}
.selspn {
  width: 31px;
  height: 31px;
  background: url('./img/group.png');
  background-size: 62px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.seletGroup{
  border: 1px solid #1677ff !important;
}
</style>
